import { Component, forwardRef } from '@angular/core';
import { RadioButtonDirective } from '@app/shared/components/radio-buttons/radio-button.directive';

@Component({
  selector: 'app-radio-group-button',
  imports: [],
  templateUrl: './radio-button.component.html',
  styleUrl: './radio-button.component.scss',
  providers: [{ provide: RadioButtonDirective, useExisting: forwardRef(() => RadioButtonComponent) }],
})
export class RadioButtonComponent<T> extends RadioButtonDirective<T> {}
